import type { DropdownOption } from "@inno-ui/dropdown";

import { Dropdown } from "@inno-ui/dropdown";

import type { Language } from "../../utils/enums";

import { useGeneralStore } from "../../store/general/general-store";
import { LANGUAGES } from "../../utils/constants";
import { FLAGS } from "./language-detector.constants";
import styles from "./language-selector.module.scss";

export function LanguageSelector() {
  const { language, setLanguage } = useGeneralStore();

  const items = Object.keys(LANGUAGES).map(lang => ({
    label: lang.toUpperCase(),
    avatar: FLAGS[lang as Language],
    value: lang,
  }));

  return (
    <div className={styles.languageSelector}>
      <Dropdown
        items={items}
        placeholder="Select Language"
        value={language}
        isSearchable={false}
        showHandleLine={false}
        width="10rem"
        listWidth="10rem"
        onChange={(e) => {
          setLanguage((e as DropdownOption).value as Language);
        }}
      />
    </div>
  );
}
